/* unplugin-vue-components disabled */import script from "./JackpotSyncBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./JackpotSyncBanner.vue?vue&type=script&setup=true&lang=js"

import "./JackpotSyncBanner.vue?vue&type=style&index=0&id=057a5500&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-057a5500"]])

export default __exports__